import { supabase } from '../supabase/supabase';
import { v4 as uuidv4 } from 'uuid';

const VISITOR_KEY = 'stark_visitor_id';
const SESSION_KEY = 'stark_session_id';

export const analyticsService = {
  init() {
    let visitorId = localStorage.getItem(VISITOR_KEY);
    if (!visitorId) {
      visitorId = uuidv4();
      localStorage.setItem(VISITOR_KEY, visitorId);
    }
    return visitorId;
  },

  async startSession(path) {
    const visitorId = this.init();
    const { data, error } = await supabase
      .from('analytics_sessions_2024')
      .insert([
        { 
          visitor_id: visitorId, 
          path, 
          user_agent: navigator.userAgent 
        }
      ])
      .select()
      .single();

    if (data) {
      sessionStorage.setItem(SESSION_KEY, data.id);
    }
    return data;
  },

  async endSession() {
    const sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) return;

    const startTime = new Date(sessionStorage.getItem('session_start_time') || Date.now());
    const endTime = new Date();
    const duration = Math.floor((endTime - startTime) / 1000);

    await supabase
      .from('analytics_sessions_2024')
      .update({ 
        ended_at: endTime.toISOString(),
        duration_seconds: duration
      })
      .eq('id', sessionId);
  },

  async getStats(range = 'all') {
    let query = supabase.from('analytics_sessions_2024').select('*');
    
    const now = new Date();
    if (range === 'today') {
      query = query.gte('started_at', new Date(now.setHours(0,0,0,0)).toISOString());
    } else if (range === 'week') {
      const weekAgo = new Date(now.setDate(now.getDate() - 7));
      query = query.gte('started_at', weekAgo.toISOString());
    }

    const { data } = await query;
    
    const uniqueVisitors = new Set(data?.map(s => s.visitor_id)).size;
    const avgDuration = data?.length ? data.reduce((acc, s) => acc + (s.duration_seconds || 0), 0) / data.length : 0;

    return {
      totalVisits: data?.length || 0,
      uniqueVisitors,
      avgDuration: Math.round(avgDuration),
      sessions: data || []
    };
  }
};